import { render } from "./vNav.vue?vue&type=template&id=2648d469&scoped=true"
import script from "./vNav.vue?vue&type=script&lang=js"
export * from "./vNav.vue?vue&type=script&lang=js"

import "./vNav.vue?vue&type=style&index=0&id=2648d469&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2648d469"]])

export default __exports__